import axios from 'axios';
import {makeAutoObservable} from 'mobx';
import { api } from '../../../api/endpoints';
import AppStore from '../../../app.store';
import { ClientsModel } from '../clients.model';
import { toast } from 'react-toastify';
import {ClientDocumentsModel} from "../client.documents/client.documents.model";
import ClientsStatusesStore from "../clients.statuses/clients.statuses.store";
import ClientsLeadQualitiesStore from "../clients.lead.qualities/clients.lead.qualities.store";

import {getRequestErrorReason} from '../../../utils/requestError';

const initialValues: ClientsModel = {
    lead_quality_color: "",
    lead_quality_id: 0,
    lead_quality_name: "",
    status_color: "",
    status_id: 0,
    status_name: "",
    email: '',
    full_name: '',
    pseudonym: '',
    patronymic: '',
    phone: '',
    id: 0,
    client_owner_id: 0,
    address: '',
    current_address: '',
    company: '',
    inn: '',
    type_id: 1,
    client_types: '',
    balance: 0,
    created_at: '',
    city_id: 1,
    files: [],
};

const documentInitialValues: ClientDocumentsModel = {
    id: 0,
    client_id: 0,
    name: '',
    surname: '',
    patronymic: '',
    series: '',
    number: '',
    inn: '',
    address: '',
    issued_by: '',
    issue_date_text: '',
    expiration_date_text: '',
    type_id: 1, //1 pass, 2-driver license, 3-military ticket, 4-pension doc, 5-other
    extra: '',
    blood_type: '',
    family_status: 0, //1-Состоит в браке 2-Не состоит в браке,
    gender: 0, //1 муж 2 жен
    birthday: '',
    birthday_text: '',
    issue_date: '',
    expiration_date: '',
    phone: '',
}

class ClientsCreateEditStore {
    public form: ClientsModel = initialValues;
    public passportForm = documentInitialValues
    public error = '';
    public message = '';
    public isLoading = false;
    public cities: any[] = [];
    public statuses: any[] = [];
    public leadQualities: any[] = [];
    
    constructor() {
        makeAutoObservable(this);
    }

    private setStatuses(data: any) {
        this.statuses = data;
    }

    private setLeadQualities(data: any) {
        this.leadQualities = data;
    }

    public init = async (initialValue: ClientsModel | null) => {
        const {getClientStatusesReq} = ClientsStatusesStore;
        const statusesResponse = await getClientStatusesReq();
        const {statuses} = statusesResponse?.data;
        this.setStatuses(statuses);

        const {getClientLeadQualitiesReq} = ClientsLeadQualitiesStore;
        const leadQualitiesResponse = await getClientLeadQualitiesReq();
        const {client_lead_qualities} = leadQualitiesResponse?.data
        this.setLeadQualities(client_lead_qualities);

        const defaultStatus = statuses?.find((status: any) => status.is_default === true)
        const defaultLeadQuality = client_lead_qualities?.find((quality: any) => quality.is_default === true)

        await this.getCitiesReq();
        if (initialValue) {
            this.form = initialValue;
        } else {
            this.form = initialValues;
            this.form.status_id = defaultStatus?.id!;
            this.form.lead_quality_id = defaultLeadQuality?.id!;
        }
    }

    public setPassportField = (form: ClientDocumentsModel) => {
        this.passportForm = form
    }

    private createClientWithDoc = async () => {
        this.isLoading = true;
        const payload = {
            client: {
                id: this.form.id,
                full_name: this.form.full_name,
                pseudonym: this.form.pseudonym,
                phone: this.form.phone,
                email: this.form.email,
                current_address: this.form.current_address,
                company: this.form.company,
                type_id: this.form.type_id,
                inn: this.form.inn,
                balance: Number(this.form.balance),
                city_id: Number(this.form.city_id),
                status_id: Number(this.form.status_id),
                lead_quality_id: Number(this.form.lead_quality_id),
            },
            doc: {
                name: this.passportForm.name,
                surname: this.passportForm.surname,
                patronymic: this.passportForm.patronymic,
                series: this.passportForm.series,
                number: this.passportForm.number,
                inn: this.form.inn,
                address: this.passportForm.address,
                issued_by: this.passportForm.issued_by,
                issue_date_text: this.passportForm.issue_date,
                expiration_date_text: this.passportForm.expiration_date,
                gender: Number(this.passportForm.gender),
                type_id: Number(this.passportForm.type_id),
                family_status: Number(this.passportForm.family_status),
                blood_type: this.passportForm.blood_type,
                extra: this.passportForm.extra,
                birthday_text: this.passportForm.birthday,
            }
        }
        try {
            const {getToken} = AppStore
            const headers = {
                Authorization: 'Bearer ' + getToken()!
            }
                const response = await axios.post(api.client + `/with_doc`, payload, {headers});

            this.message = response?.data.message;
            toast.success(this.message);

            return response;
        } catch (err: any) {
            const reason = getRequestErrorReason(err);
            if (!reason) return;
            this.error = reason;
            toast.error(this.error);
        } finally {
            this.isLoading = false;
        }
    }

    private createOrEditClientReq = async (edit: boolean) => {
        this.isLoading = true;
        const payload = {
            id: this.form.id,
            full_name: this.form.full_name,
            pseudonym: this.form.pseudonym,
            phone: this.form.phone,
            email: this.form.email,
            current_address: this.form.current_address,
            company: this.form.company,
            type_id: this.form.type_id,
            inn: this.form.inn,
            balance: Number(this.form.balance),
            city_id: Number(this.form.city_id),
            status_id: Number(this.form.status_id),
            lead_quality_id: Number(this.form.lead_quality_id),
        }
        try {
            const {getToken} = AppStore
            const headers = {
                Authorization: 'Bearer ' + getToken()!
            }
            let res;
            if (edit) {
                res = await axios.put(api.client, payload, {headers});
            } else {
                res = await axios.post(api.client, payload, {headers});
            }
            // if (res?.code >= 400) {
            //     throw new Error(res)
            // }
            this.message = res?.data.message;
            toast.success(this.message);

            return res;
        } catch (err: any) {
            const reason = getRequestErrorReason(err);
            if (!reason) return;
            this.error = reason;
            toast.error(this.error);
        } finally {
            this.isLoading = false;
        }
    }

    public createOrEditClient = async (edit?: boolean, withDoc?: boolean) => {
        if (withDoc) {
            return this.createClientWithDoc()
        } else {
            return this.createOrEditClientReq(edit!)
        }
    }

    public setField = (form: ClientsModel) => {
        this.form = form;
    }

    public destroy = () => {
        this.form = initialValues;
        this.passportForm = documentInitialValues
    }

    public get clientTypeIDOptions() {
        return [
            {
                label: 'Физ лицо',
                value: 1,
            },
            {
                label: 'Юр лицо',
                value: 2,
            },
        ]
    }

    setCities(data: any) {
        const {cities} = data;
        this.cities = cities;
    }

    private getCitiesReq = async (signal?: AbortSignal) => {
        const {getToken} = AppStore
        const headers = {
            Authorization: 'Bearer ' + getToken()!
        }

        try {
            const response = await axios.get(api.cities, {headers, signal});
            this.setCities(response?.data);
        } catch (e) {

        }
    }

    public get citiesOptions() {
        if (!this.cities) return;

        return this.cities.map((city) => ({
            value: city.id,
            label: city.name_ru,
        }));
    }

    public get statusOptions() {
        if (!this.statuses) return;

        return this.statuses.map((status) => ({
            value: status.id,
            label: status.name,
        }));
    }

    public get leadQualityOptions() {
        if (!this.leadQualities) return;

        return this.leadQualities.map((leadQuality) => ({
            value: leadQuality.id,
            label: leadQuality.name,
        }));
    }
}

export default new ClientsCreateEditStore();